import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import usePermissions from "hooks/usePermissions";
import { Link } from "components/common";
import LicensesRoutes from "license/Routes";
const LicenseHelp = () => {
  const { t } = useTranslation("enterprise_license");
  const { isPermitted } = usePermissions();
  return isPermitted("licenses:create") ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "license.notifications.help_with_access",
      components: { licensesLink: /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }) }
    }
  )) : /* @__PURE__ */ React.createElement("span", null, t("license.notifications.help_without_access"));
};
export default LicenseHelp;
